module.exports = __webpack_public_path__ + "static/media/Places-4.46f43b5d.jpg";